
export class Icons {
  constructor(private icons: Object) {}
}
